// Standard U.S. telephone display formatting: (###) ###-####.
// Preserves the actual digits and a valid country code when supplied.
// Returns the original string untouched when it is not a recognizable number.
export const formatPhone = (raw) => {
  if (raw === null || raw === undefined) return '';
  const s = String(raw).trim();
  const digits = s.replace(/\D/g, '');
  if (!digits) return s;
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  if (digits.length > 11) {
    const cc = digits.slice(0, digits.length - 10);
    const last10 = digits.slice(-10);
    return `+${cc} (${last10.slice(0, 3)}) ${last10.slice(3, 6)}-${last10.slice(6)}`;
  }
  return s; // fewer than 10 digits — preserve exactly, do not mangle
};
